const UPDATE_COST_CENTER = "UPDATE_COST_CENTER";
const UPDATE_COST_CENTER_RESPONSE = "UPDATE_COST_CENTER_RESPONSE";
const ISVEHICLECONSOLIDATEDCHECKED = "ISVEHICLECONSOLIDATEDCHECKED";
const ISMANAGEEQUIPCONSOLIDATEDCHECKED = "ISMANAGEEQUIPCONSOLIDATEDCHECKED";
const ISNONSTANDARDCONSOLIDATEDCHECKED = "ISNONSTANDARDCONSOLIDATEDCHECKED";
const IS_SAVE_PURCHASE_ORDER_LOADING = "IS_SAVE_PURCHASE_ORDER_LOADING";
const GET_FLEET_PO = "GET_FLEET_PO";
const SET_FLEET_PO = "SET_FLEET_PO";
const SET_DISPOSITION_DATA = "SET_DISPOSITION_DATA"; 
const SET_TRANSFER_DATA = "SET_TRANSFER_DATA"; 
const SET_INITIAL_DISPOSITION_DATA = "SET_INITIAL_DISPOSITION_DATA"
const VALIDATE_AND_SAVE_MULTIPLE_PO = 'VALIDATE_AND_SAVE_MULTIPLE_PO'
const SET_VALIDATE_AND_SAVE_MULTIPLE_PO_SUCCESS = 'SET_VALIDATE_AND_SAVE_MULTIPLE_PO_SUCCESS'
const CREATE_CONSOLIDATED_PO = 'CREATE_CONSOLIDATED_PO'
const CREATE_CONSOLIDATED_PO_RESPONSE = 'CREATE_CONSOLIDATED_PO_RESPONSE'

export
{
    UPDATE_COST_CENTER,
    UPDATE_COST_CENTER_RESPONSE,
    GET_FLEET_PO,
    SET_FLEET_PO,
    ISVEHICLECONSOLIDATEDCHECKED,
    ISMANAGEEQUIPCONSOLIDATEDCHECKED,
    ISNONSTANDARDCONSOLIDATEDCHECKED,
    IS_SAVE_PURCHASE_ORDER_LOADING,
    SET_DISPOSITION_DATA,
    SET_TRANSFER_DATA,
    SET_INITIAL_DISPOSITION_DATA,
    VALIDATE_AND_SAVE_MULTIPLE_PO,
    SET_VALIDATE_AND_SAVE_MULTIPLE_PO_SUCCESS,
    CREATE_CONSOLIDATED_PO,
    CREATE_CONSOLIDATED_PO_RESPONSE
};
